import React from "react";

export const Share = () => {
  return (
    <svg
      width="11.5"
      height="12.86"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.48425 0.782227C8.36304 0.782227 7.45411 1.69115 7.45411 2.81237C7.45411 2.99134 7.47727 3.16491 7.52075 3.33023C7.4728 3.34014 7.42548 3.35721 7.38026 3.38187L5.51488 4.39935L3.14202 5.75527C3.11777 5.76913 3.09509 5.78469 3.07406 5.80171C2.77129 5.62225 2.41787 5.51923 2.0404 5.51923C0.91918 5.51923 0.0102539 6.42815 0.0102539 7.54937C0.0102539 8.67058 0.91918 9.57951 2.0404 9.57951C2.63189 9.57951 3.1643 9.32655 3.53536 8.92291L5.51583 10.0232L7.51512 11.1137C7.47527 11.2724 7.45411 11.4386 7.45411 11.6097C7.45411 12.7309 8.36304 13.6398 9.48425 13.6398C10.6055 13.6398 11.5144 12.7309 11.5144 11.6097C11.5144 10.4884 10.6055 9.57951 9.48425 9.57951C8.89928 9.57951 8.37209 9.82693 8.00162 10.2228L6.00707 9.13489L4.0139 8.02757C4.05092 7.87422 4.07054 7.71409 4.07054 7.54937C4.07054 7.18415 3.9741 6.84146 3.8053 6.54536L6.00977 5.28566L7.86633 4.273C7.9117 4.24825 7.95178 4.21759 7.98615 4.18249C8.35734 4.58812 8.89109 4.84251 9.48425 4.84251C10.6055 4.84251 11.5144 3.93359 11.5144 2.81237C11.5144 1.69115 10.6055 0.782227 9.48425 0.782227Z"
        fill="#474747"
      />
    </svg>
  );
};
